// Project versioning: the trail row a special-condition change carries.
//
// Same shape as buildWasteVersionInput — a display-only log line (summary + optional entity
// label), not state. A revision's special-condition mappings ARE the rows in
// project_special_condition_type_mapping, scoped by revision_id, which the BEFORE INSERT trigger
// stamps. Nothing folds trail rows back into a read, so a missing row costs a history line and
// never correctness.
//
// entityType is the snake_case DB value; the history page camel-cases it for display
// (normalizeEntityType in ../services/versionMapping.ts). It only became writable in Hasura
// migration 1787000000000, which widened the project_version entity_type check constraint —
// before that, an insert naming it was rejected, which is why these changes left no trail at all.

export interface SpecialConditionVersionDescriptor {
  projectId: string;
  operation: "create" | "update" | "delete";
  summary: string;
  entityId?: string | null;
  entityLabel?: string | null;
  changes?: { field: string; from: string | null; to: string | null; unit?: string }[];
}

/**
 * The projectVersion_insert_input for a special-condition change. created_by / tenant_id / source
 * are stamped server-side via permission presets, and revision_id is not insertable at all — so
 * this object carries only what a human reads.
 */
export const buildSpecialConditionVersionInput = ({
  projectId,
  operation,
  summary,
  entityId,
  entityLabel,
  changes,
}: SpecialConditionVersionDescriptor) => ({
  projectId,
  entityType: "special_condition",
  operation,
  summary,
  entityId: entityId ?? null,
  entityLabel: entityLabel ?? null,
  changes: changes ?? [],
});
